import RefreshUrl from "../Component/RefreshUrl";
import { connect } from 'react-redux';
import { loginWithStripe } from '../../../Action';

const mapStateToProps = (state) => {
  let { StripeLogin } = state;
  return {
    StripeLogin
  }
}
const actionCreators = {
  loginWithStripe
}
export default (connect(mapStateToProps, actionCreators)(RefreshUrl));